import React from 'react';
import { SavedQueryCategory } from '@/views/SavedQueries/types';
import { rootDomain } from '@/util/helpers/essential-helpers';
import { datasourceId } from '@/util/helpers/ajax-helpers';
import { FilterItem } from './subcomponents/FilterItem';
import styles from './CategoryFilters.module.scss';

const getPath = (categoryId: string) =>
  `${rootDomain()}/datasources/${datasourceId()}/category-filter/${categoryId}/open`;

export type CategoryFiltersProps = {
  categories: SavedQueryCategory[];
  appliedFilter: Maybe<SavedQueryCategory>;
  onApplyFilter: F<SavedQueryCategory, void>;
  onEdit: F<SavedQueryCategory, F0<void>>;
  onDelete: F<SavedQueryCategory, F0<void>>;
};

export const CategoryFilters: React.FC<CategoryFiltersProps> = ({
  categories,
  appliedFilter,
  onApplyFilter,
  onEdit,
  onDelete,
}) => (
  <>
    <small className={styles.header}>CATEGORIES</small>
    {categories.length === 0 ? (
      <small className={styles.noCategoriesMessage}>
        Add categories when you save a query
      </small>
    ) : (
      categories.map((category) => (
        <FilterItem
          key={`tag_${category.id()}`}
          category={category}
          active={appliedFilter?.id?.() === category.id()}
          path={getPath(category.id())}
          onApplyFilter={() => onApplyFilter(category)}
          onEdit={onEdit(category)}
          onDelete={onDelete(category)}
        />
      ))
    )}
  </>
);
